/**
 * Commissions Detail Component
 */
import { setShowCommissionsDetail } from "containers/Card/store/Actions";
import { ICommissionConfig } from "containers/Card/store/CardState";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { calculateTotalAmount, getCurrencySymbol } from "root/shared/Utility";
import { CajitaStore } from "root/store/CajitaStore";
import { ITransferAmount } from "types/transfer_amount";

interface ICommissionsDetailProps {
  configAmount: number;
  commissionConfig: ICommissionConfig;
  currencySymbol: string;
  showCommissionsDetail?: boolean;
  // tslint:disable-next-line
  [k: string]: any;
}

interface ICommissionsDetailActionTypes {
  type: string;
  showCommissionsDetail?: boolean;
}
/**
 * Commissions Detail Component Class
 */
class CommissionsDetail extends React.Component<ICommissionsDetailProps> {
  constructor(props: ICommissionsDetailProps) {
    super(props);
    this._handleBackToPaymentClick = this._handleBackToPaymentClick.bind(this);
  }

  public render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.showCommissionsDetail}
        toggle={this._handleBackToPaymentClick}
        className="modalMaxWidthHeight"
        contentClassName="modalMaxWidthHeight"
      >
        <ModalHeader toggle={this._handleBackToPaymentClick}>
          <div className="text-center commissionTitle">
            <h5>
              <Translate id="commission.title" />
            </h5>
          </div>
        </ModalHeader>
        <ModalBody className="language-modal-body">
          <Container className="mw-100">
            <Row className="mb-1 mt-1">
              <Col>
                <Translate id="commission.text" />
              </Col>
            </Row>
            <br />
            <Row key="configAmount" className="commissionValueFont">
              <Col xs="8" className="mb-2 commissionValue">
                {this.props.commissionConfig.parentMerchantName}
              </Col>
              <Col xs="4" className="mb-2 align-right">
                {this.props.currencySymbol} {this.props.configAmount.toFixed(2)}
              </Col>
            </Row>
            <Row key="commissionAmount" className="commissionValueFont">
              <Col xs="8" className="commissionValue">
                {this.props.commissionConfig.commissionMerchantName}
              </Col>
              <Col xs="4" className="align-right">
                {this.props.currencySymbol}{" "}
                {this.props.commissionConfig.totalAmount.toFixed(2)}
              </Col>
            </Row>
            <hr />
            <Row className="commissionValueFont">
              <Col xs="8">Total</Col>
              <Col xs="4" className="align-right">
                {this.props.currencySymbol}{" "}
                {(
                  this.props.commissionConfig.totalAmount +
                  this.props.configAmount
                ).toFixed(2)}
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    );
  }

  private _handleBackToPaymentClick(): void {
    this.props.onHideCommissionsDetail();
  }
}

const mapStateToProps: (state: CajitaStore) => ICommissionsDetailProps = (
  state: CajitaStore
): ICommissionsDetailProps => ({
  showCommissionsDetail: state.card.showCommissionsDetail,
  commissionConfig: state.card.commissionConfig,
  configAmount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : Number(state.config.amount),
  currencySymbol: getCurrencySymbol(state.config.currency),
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, ICommissionsDetailActionTypes>
): object => ({
  onHideCommissionsDetail: (): ICommissionsDetailActionTypes =>
    dispatch(setShowCommissionsDetail(false)),
});

const CommissionsDetailComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommissionsDetail);

export { CommissionsDetailComponent };



// WEBPACK FOOTER //
// ./src/components/CommissionsDetailView/CommissionsDetailComponent.tsx